export enum ReminderChannel {
	APP = "app",
	EMAIL = "email",
	BOTH = "both"
}

export class CalendarEventReminder {
	ID:number = 0;
	EventID:number = 0;
	UserID:number = 0;
	MinutesBefore:number = 30;
	Channel:ReminderChannel = ReminderChannel.APP;

	constructor(data?:any) {
		if (!data) return;
		this.ID = data.ID || 0;
		this.EventID = data.EventID || 0;
		this.UserID = data.UserID || 0;
		this.MinutesBefore = data.MinutesBefore || 0;
		this.Channel = data.Channel || ReminderChannel.APP;
	}

	getJSON() {
		return {
			ID: this.ID,
			EventID: this.EventID,
			UserID: this.UserID,
			MinutesBefore: this.MinutesBefore,
			Channel: this.Channel
		};
	}
}
